import React from 'react';
import styles from './tooltip.scss';
import PropTypes from 'prop-types';

class Tooltip extends React.Component {
  render() {
    const { isVisible, top, left } = this.props;
    return (
      <div
        className={`${styles.tooltip} ${isVisible
          ? styles.tooltipVisible
          : ''}`}
        style={{ top, left }}
        onMouseEnter={this.props.onMouseEnter}
        onMouseLeave={this.props.onMouseLeave}
      >
        <div className={styles.tooltipInner}>
          <div className={styles.tooltipContent}>{this.props.children}</div>
        </div>
      </div>
    );
  }
}

Tooltip.propTypes = {
  isVisible: PropTypes.bool,
  top: PropTypes.number,
  left: PropTypes.number,
  title: PropTypes.string,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
};

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/tooltip/tooltip.js